import { render } from "./thankyoupageRM.vue?vue&type=template&id=0fe43abe&scoped=true"
import script from "./thankyoupageRM.vue?vue&type=script&lang=js"
export * from "./thankyoupageRM.vue?vue&type=script&lang=js"

import "./thankyoupageRM.vue?vue&type=style&index=0&id=0fe43abe&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe43abe"]])

export default __exports__